/**
 * Desktop League V2 wizard measures.
 * The shell stops near 1000px. Form sections sit inside that, and choice
 * controls use a content width instead of stretching with the viewport.
 */
export const wizardLayout = {
  shell: "mx-auto w-full max-w-[1000px]",
  section: "w-full max-w-full",
  choices: "flex flex-wrap gap-3",
  choice: "w-64",
} as const;
